/**
 * FocusDebugOverlay — diagnostic used to trace the "growing tile" bug
 * during v1.4.55–v1.4.59. The bug was root-caused to a ResizeObserver
 * feedback loop in `VirtualTileGrid.jsx` and fixed properly in
 * v1.4.60. This component is now a no-op; kept so its App.js import
 * still resolves and so we have a home to reinstate diagnostics if
 * a similar issue re-emerges.
 *
 * If you need it again, restore the old body from git history at:
 *   git log -p -- frontend/src/player/components/FocusDebugOverlay.jsx
 */
export default function FocusDebugOverlay() {
  return null;
}
